module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2013-12-13.5a50ece1.md";